import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import PropTypes from "prop-types";
import { Dialog, DialogContent, Button, Typography, Box } from "@mui/material";
import styles from "./styles.module.css";
import logoAzul from "../../images/fenix_azul.png";
import useWindowSize from "react-use/lib/useWindowSize";
import Confetti from "react-confetti";
import { TipoCadastroPlanTrib, Email } from "../../utils/localStorage.util";
import Header from "../../components/Header";
import { buscarStatus } from "../../services/api-planejamento-tributario.service";
import { NovoCliente } from "../../components/NovoCliente";
import { LoginContext } from "../../config/Context/LoginContext";
import { CadastroContext } from "../../config/Context/CadastroContext";
import SolicitacoesWorkflow from "./widgets/SolicitacoesWorflow";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export const Dashboard = () => {
  const location = useLocation();
  const [openDialog, setOpenDialog] = useState(false);
  const [showConfetti, setShowConfetti] = useState(false);
  const [isCliente, setIsCliente] = useState(false);
  const { dados, setDados } = useContext(CadastroContext);
  const { dadosLogin } = useContext(LoginContext);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      const searchParams = new URLSearchParams(location.search);
      const cadastroParam = searchParams.get("cadastro");
      if (cadastroParam === "true") {
        setOpenDialog(true);
        setShowConfetti(true);
      } else {
        setShowConfetti(false);
      }

      const clienteParam = searchParams.get("cliente");
      if (clienteParam === "true") {
        setIsCliente(true);
        setOpenDialog(true);
        setShowConfetti(true);
      } else {
        setIsCliente(false);
      }

      const tipoCadastroPlanTrib = dadosLogin.tipoCadastroPlanTribKey;
      let status;
      try {
        const response = await buscarStatus();
        status = response?.status;
      } catch (e) {
        console.warn("[Dashboard] buscarStatus:", e?.message || e);
        status = undefined;
      }

      if (!status) return;
      try {

        switch (status) {
          case "CADASTRARDET":
            if (tipoCadastroPlanTrib === "A") {
              // CadastroDetalhado.setCadastroDetalhado(true);
              setDados({ ...dados, tipo: "A" });
              navigate(`/cadastrar-cnpj`);
            } else if (tipoCadastroPlanTrib === "P") {
              // CadastroDetalhado.setCadastroDetalhado(true);
              setDados({ ...dados, tipo: "P" });
              navigate(`/cadastrar-cnpj`);
            } else if (tipoCadastroPlanTrib === "C") {
              // CadastroDetalhado.setCadastroDetalhado(true);
              setDados({ ...dados, tipo: "C" });
              navigate(`/cadastrar-cliente-detalhado`);
            }
            break;
          case "PENDENTE-EDICAO":
            if (tipoCadastroPlanTrib === "A") {
              // CadastroDetalhado.setCadastroDetalhado(true);
              setDados({ ...dados, tipo: "A" });
            } else if (tipoCadastroPlanTrib === "P") {
              // CadastroDetalhado.setCadastroDetalhado(true);
              setDados({ ...dados, tipo: "P" });
            } else if (tipoCadastroPlanTrib === "C") {
              // CadastroDetalhado.setCadastroDetalhado(true);
              setDados({ ...dados, tipo: "C" });
            }
            navigate(`/editar-dados-candidato`);
            break;
          case "TIPOSNEGOCIO":
            navigate(`/selecionar-tipos-negocio`);
            break;
          case "ANALISANDO":
            navigate(`/proposta-em-analise`);
            break;
          case "VEREMAIL":
            navigate(`/validar-codigo-email?endereco=${dadosLogin.email}`);
            break;
          case "AGUARD_ASSINATURA":
            navigate(`/aguardando-assinatura`);
            break;

          default:
            break;
        }
      } catch (error) {
        console.error("Erro ao buscar status do usuário:", error);
      }
    };

    fetchData();
  }, [location.search]);

  useEffect(() => {
    localStorage.removeItem("reload");
  }, []);

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setShowConfetti(false);
  };
  const { width, height } = useWindowSize();

  const handleCadastrarNovoCliente = () => {
    setDados({ ...dados, tipo: "C" });
    navigate("/cadastrar-cnpj");
  };

  return (
    <>
      <div className={styles.widget}>
        <SolicitacoesWorkflow />
      </div>
      <div className={styles.divPrincipal}>
        {showConfetti && <Confetti width={width} height={height} />}

        <Dialog
          className={styles.dialog}
          open={openDialog}
          onClose={handleCloseDialog}
        >
          <div className={styles.container}>
            <img className={styles.imgLogo} src={logoAzul} alt="logo.png" />
          </div>
          <DialogContent>
            <div className={styles.container}>
              <NovoCliente />
            </div>
            {isCliente && (
              <p className={styles.pergunta}>
                Deseja cadastrar um novo cliente?
              </p>
            )}
            <div className={styles.container}>
              <Button
                className={styles.botaoOkCadastro}
                onClick={handleCloseDialog}
                style={{ display: isCliente ? "none" : "block" }}
              >
                OK
              </Button>
            </div>

            <div className={styles.container}>
              <Button
                className={styles.botaoSim}
                onClick={handleCadastrarNovoCliente}
                style={{ display: !isCliente ? "none" : "block" }}
              >
                Sim
              </Button>
              <Button
                className={styles.botaoNao}
                onClick={handleCloseDialog}
                style={{ display: !isCliente ? "none" : "block" }}
              >
                Não
              </Button>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
};
